export default function HeroBackground() {
  return (
    <div className="absolute inset-0">
      <img
        src="/hero-workers.png"
        alt="California workers from all industries"
        className="w-full h-full object-cover"
        style={{ objectPosition: '50% 20%' }}
        loading="eager"
      />
      <video
        autoPlay muted playsInline
        poster="/hero-workers.png"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: '50% 20%' }}
      >
        <source src="/hero-workers.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-cwc-navy/65 via-cwc-navy/35 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-cwc-navy/30 via-transparent to-cwc-navy/10" />
    </div>
  );
}
